import graphql__3107d69d4cfa4d6e9b37 from "./__generated__/StoreVisitorIdMutation.graphql.js";import { commitMutation } from "react-relay";
import { graphql } from "react-relay";
import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__3107d69d4cfa4d6e9b37;

function storeVisitorId(variables, onCompleted) {
  return commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted,
    onError: error => console.error(error)
  });
}

export { storeVisitorId };
